// External
import React, { useEffect, useState } from 'react';
import { Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { useHistory } from 'react-router-dom';

// Internal
import Root from '../app/Root';
import { Spinner } from '../components/';

// Constants
const { VITE_OAUTH_CLIENT_ID, VITE_OAUTH_CALLBACK_URL, VITE_OAUTH_ISSUER } = import.meta.env;

const HomePage = () => {
  const history = useHistory();
  const [isCheckingForExistingSession, setIsCheckingForExistingSession] = useState(true);

  const oktaAuth = new OktaAuth({
    clientId: VITE_OAUTH_CLIENT_ID,
    issuer: VITE_OAUTH_ISSUER,
    redirectUri: window.location.origin + VITE_OAUTH_CALLBACK_URL,
    pkce: true,
    scopes: ['email', 'openid', 'profile']
  });

  // If user is logged into Gameday already, use the same session
  useEffect(() => {
    oktaAuth.start();

    oktaAuth.session.exists().then(exists => {
      const isLoginRedirect = oktaAuth.isLoginRedirect();

      if (exists && !isLoginRedirect) {
        // logged in
        oktaAuth.token
          .getWithoutPrompt({ responseType: 'id_token' })
          .then(res => {
            const { tokens } = res;

            oktaAuth.tokenManager.setTokens(tokens);
          })
          .catch()
          .finally(() => {
            setIsCheckingForExistingSession(false);
          });
      } else {
        setIsCheckingForExistingSession(false);
      }
    });
  }, []);

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri, window.location.origin));
  };

  const onAuthRequired = () => history.push('/login');

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri} onAuthRequired={onAuthRequired}>
      {isCheckingForExistingSession ? <Spinner large /> : <Root />}
    </Security>
  );
};

export default HomePage;
